import React from 'react';

import { useForm } from 'react-hook-form';
import { useUpdateEffect } from 'react-use';

import { LbSelect } from '@infoods/lifebase-ui';
import { ModalInputBox, ModalInputGroup } from '../../../../shared/components/modals';

import { ComboBox } from '../../../../shared/components/form-components';
import { ScanSummaryModalFormValues } from '../NgzScanSummaryModal.settings';
import { ScanMetadata } from '../../../interfaces/scanMetadata';
import { Option } from '../../../../general-types';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { useScanRangeOptions } from '../../../hooks/useScanRangeOptions/useScanRangeOptions';
import { useFilterScansByInbodyType } from '../../../hooks/useFilterScansByInbodyType/useFilterScansByInbodyType';

type SelectScansFormSectionProps = {
  scansMetadata: ScanMetadata[];
  inbodyTypeOptions: Option[];
  defaultValues: ScanSummaryModalFormValues;
  onSubmit: (data: ScanSummaryModalFormValues) => void;
};

const SelectScansFormSection = ({
  scansMetadata,
  inbodyTypeOptions,
  defaultValues,
  onSubmit,
}: SelectScansFormSectionProps) => {
  const { control, handleSubmit, watch, setValue } = useForm<ScanSummaryModalFormValues>({
    defaultValues,
  });

  useAutoSubmitForm(handleSubmit(onSubmit), watch);

  const { inbodyType: selectedInbodyType, startScanId, endScanId } = watch();

  useUpdateEffect(() => {
    setValue('startScanId', null);
    setValue('endScanId', null);
  }, [selectedInbodyType]);

  const filteredScansMetadata = useFilterScansByInbodyType(
    scansMetadata,
    selectedInbodyType,
  );

  const { startScanOptions, endScanOptions } = useScanRangeOptions({
    scansMetadata: filteredScansMetadata,
    startScanId,
    endScanId,
  });

  const generalInputProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  const isSelectScansDisabled = !selectedInbodyType;

  return (
    <ModalInputBox title="Select InBody Machine and scans dates for the period you want to compare">
      <LbSelect
        {...generalInputProps}
        name="inbodyType"
        label="InBody Machine"
        options={inbodyTypeOptions}
      />
      <ModalInputGroup>
        <ComboBox
          {...generalInputProps}
          name="startScanId"
          label="Start Scan Date"
          options={startScanOptions}
          rules={{ required: 'Start Scan Date is required' }}
          disabled={isSelectScansDisabled}
        />
        <ComboBox
          {...generalInputProps}
          name="endScanId"
          label="End Scan Date"
          options={endScanOptions}
          rules={{ required: 'End Scan Date is required' }}
          disabled={isSelectScansDisabled}
        />
      </ModalInputGroup>
    </ModalInputBox>
  );
};

export { SelectScansFormSection };
